import { ButtonConfig } from "./button-config";
import { CryptoService } from '../base-services/crypto.service';


export class DefaultButtonsConfig {

    constructor(
        addEnable: boolean = true
        , addVisible: boolean = true
        , deleteEnable: boolean = true
        , deleteVisible: boolean = true
        , saveEnable: boolean = true
        , saveVisible: boolean = true
        , editEnable: boolean = true
        , editVisible: boolean = true
        , lockEnable: boolean = true
        , lockVisible: boolean = true
        ,printEnable: boolean = true
        , printVisible: boolean = true
        ,resetEnable: boolean = true
        ,resetVisible: boolean = true
        ,contextMenuEnable: boolean = true
        , contextMenuVisible: boolean = true
        , closeEnable: boolean = true
        , closeVisible: boolean = true

    ){

        const configs: { key: keyof DefaultButtonsConfig; enable: boolean; visible: boolean }[] = [
            { key: 'AddButtonConfig', enable: addEnable, visible: addVisible },
            { key: 'DeleteButtonConfig', enable: deleteEnable, visible: deleteVisible },
            { key: 'SaveButtonConfig', enable: saveEnable, visible: saveVisible },
            { key: 'EditButtonConfig', enable: editEnable, visible: editVisible },
            { key: 'LockButtonConfig', enable: lockEnable, visible: lockVisible },
            { key: 'PrintButtonConfig', enable: printEnable, visible: printVisible },
            { key: 'ResetButtonConfig', enable: resetEnable, visible: resetVisible },
            { key: 'ContextMenuButtonConfig', enable: contextMenuEnable, visible: contextMenuVisible },
            { key: 'CloseButtonConfig', enable: closeEnable, visible: closeVisible },

        ];

        configs.forEach(({ key, enable, visible }) => {
            (this[key as keyof DefaultButtonsConfig] as ButtonConfig) = this.createButtonConfig(enable, visible);
        });
        
        
//        this.AddButtonConfig=new ButtonConfig(addEnable, addVisible);
        // this.AddButtonConfig = this.createButtonConfig(addEnable, addVisible);
        // this.DeleteButtonConfig=new ButtonConfig(deleteEnable, deleteVisible);
        // this.SaveButtonConfig = new ButtonConfig(saveEnable, saveVisible);
        // this.EditButtonConfig = new ButtonConfig(editEnable, editVisible);
        // this.LockButtonConfig = new ButtonConfig(lockEnable, lockVisible);
        //this.DeleteAllButtonConfig = new ButtonConfig(true, true);
        this.DeleteAllButtonConfig = this.createButtonConfig(true, true);
        this.ShowToolbar = true;
        this.ShowAddButton = true;
        this.ShowDeleteAllButton = true;
        this.ShowPrintButton = true;
        this.ShowResetButton = true;
        this.ShowContextMenuButton = true;
    }

    AddButtonConfig: ButtonConfig;
    DeleteButtonConfig: ButtonConfig;
    SaveButtonConfig: ButtonConfig;
    EditButtonConfig: ButtonConfig;
    LockButtonConfig: ButtonConfig;
    DeleteAllButtonConfig: ButtonConfig;
    PrintButtonConfig: ButtonConfig;
    ResetButtonConfig: ButtonConfig;
    ContextMenuButtonConfig: ButtonConfig;
    ShowToolbar: boolean;
    ShowAddButton: boolean;
    ShowDeleteAllButton: boolean;
    ShowPrintButton: boolean;
    ShowResetButton: boolean;
    ShowContextMenuButton: boolean;
    CloseButtonConfig: ButtonConfig;

    private createButtonConfig(enable: boolean, visible: boolean): ButtonConfig {
        return new ButtonConfig(enable, visible);
    }

    private updateButtonConfig(target: ButtonConfig, source: ButtonConfig): void {
        if (source.Enable != null) target.Enable = source.Enable;
        if (source.Visible != null) target.Visible = source.Visible;
    }

    // LoadButtonsConfigData(data: DefaultButtonsConfig){
    //     let listButtonsConfigData: DefaultButtonsConfig= new DefaultButtonsConfig();
    //     if (data){
    //         if (data.AddButtonConfig){
    //             if (data.AddButtonConfig.Enable!=null)
    //                 listButtonsConfigData.AddButtonConfig.Enable=data.AddButtonConfig.Enable;
    //             if (data.AddButtonConfig.Visible!=null)
    //                 listButtonsConfigData.AddButtonConfig.Visible=data.AddButtonConfig.Visible;
    //         }
    //         if (data.DeleteButtonConfig){
    //             if (data.DeleteButtonConfig.Enable!=null)
    //                 listButtonsConfigData.DeleteButtonConfig.Enable=data.DeleteButtonConfig.Enable;
    //             if (data.DeleteButtonConfig.Visible!=null)
    //                 listButtonsConfigData.DeleteButtonConfig.Visible=data.DeleteButtonConfig.Visible;
    //         }
    //         if(data.SaveButtonConfig) {
    //             if(data.SaveButtonConfig.Enable != null)
    //                 listButtonsConfigData.SaveButtonConfig.Enable = data.SaveButtonConfig.Enable;
    //             if(data.SaveButtonConfig.Visible != null)
    //                 listButtonsConfigData.SaveButtonConfig.Visible = data.SaveButtonConfig.Visible;
    //         }
    //         if(data.LockButtonConfig) {
    //             if(data.LockButtonConfig.Enable != null)
    //                 listButtonsConfigData.LockButtonConfig.Enable = data.LockButtonConfig.Enable;
    //             if(data.LockButtonConfig.Visible != null)
    //                 listButtonsConfigData.LockButtonConfig.Visible = data.LockButtonConfig.Visible;
    //         }
    //     }
    //     return listButtonsConfigData;
    // }

    LoadButtonsConfigData(data: DefaultButtonsConfig): DefaultButtonsConfig {
        const listButtonsConfigData = new DefaultButtonsConfig();
        if (data) {
            this.updateButtonConfig(listButtonsConfigData.AddButtonConfig, data.AddButtonConfig);
            this.updateButtonConfig(listButtonsConfigData.DeleteButtonConfig, data.DeleteButtonConfig);
            this.updateButtonConfig(listButtonsConfigData.SaveButtonConfig, data.SaveButtonConfig);
            this.updateButtonConfig(listButtonsConfigData.LockButtonConfig, data.LockButtonConfig);
            this.updateButtonConfig(listButtonsConfigData.PrintButtonConfig, data.PrintButtonConfig);
            this.updateButtonConfig(listButtonsConfigData.ResetButtonConfig, data.ResetButtonConfig);
            this.updateButtonConfig(listButtonsConfigData.ContextMenuButtonConfig, data.ContextMenuButtonConfig);
            this.updateButtonConfig(listButtonsConfigData.CloseButtonConfig, data.CloseButtonConfig);

        }
        return listButtonsConfigData;
    }


    GetConfig(userRightsModelName: string, showCheckBoxes: boolean, toolbarConfig: any) {
        // console.log('GetConfig called');
        
        // if(!sessionStorage.getItem('yt-user-rights'))
        //     return this;
        // if(!JSON.parse(sessionStorage.getItem('yt-user-rights')).Values[userRightsModelName])
        //     return this;

        //const userRightsData = sessionStorage.getItem('yt-user-rights');
        const encrypted = sessionStorage.getItem('yt-user-rights');
        let userRights
        let userRightsData

        if (encrypted) {
          try {
            userRightsData = CryptoService.Decrypt(encrypted);
          } catch (e) {
            console.error('Decription failed:', e)
          }
        }
        if (!userRightsData) return this;
    
        // const userRightsParsed = JSON.parse(userRightsData);
//        const userRights = userRightsParsed?.Values?.[userRightsModelName];
        userRights = userRightsData.Values[userRightsModelName];
        if (!userRights) return this;

//        let userRights = JSON.parse(sessionStorage.getItem('yt-user-rights')).Values[userRightsModelName];
        this.AddButtonConfig.Enable = this.AddButtonConfig.Visible = userRights['add'];
        this.DeleteButtonConfig.Enable = this.DeleteButtonConfig.Visible = userRights['delete'];
        this.EditButtonConfig.Enable = this.EditButtonConfig.Visible = userRights['edit'];
        this.DeleteAllButtonConfig.Enable = this.DeleteAllButtonConfig.Visible = userRights["delete"] && showCheckBoxes;;
        this.LockButtonConfig.Enable = this.LockButtonConfig.Visible = userRights['lock'];
        this.PrintButtonConfig.Enable = this.PrintButtonConfig.Visible = userRights['print'];
        this.ContextMenuButtonConfig.Enable = this.ContextMenuButtonConfig.Visible = false;
        this.ShowToolbar = toolbarConfig.showToolbar;
        this.ShowAddButton = toolbarConfig.showAddButton;
        this.ShowPrintButton = toolbarConfig.ShowPrintButton;
        this.ShowDeleteAllButton = toolbarConfig.showDeleteAllButton;
        this.ShowPrintButton = toolbarConfig.showPrintButton;
        this.ShowResetButton = toolbarConfig.ShowResetBtton;
        this.ShowContextMenuButton = toolbarConfig.ShowContextMenuButton;
        this.CloseButtonConfig.Enable = this.CloseButtonConfig.Visible = true;
        // Object.assign(this, {
        //     ShowToolbar: toolbarConfig.showToolbar ?? true,
        //     ShowAddButton: toolbarConfig.showAddButton ?? true,
        //     ShowDeleteAllButton: toolbarConfig.showDeleteAllButton ?? true,
        //     ShowPrintButton: toolbarConfig.showPrintButton ?? true
        // });
    

        return this;
    }
}
